import React from 'react'
import {
    Divider,
    Typography,
    makeStyles,
} from "@material-ui/core";
import theme from "js/material-ui-theme"


interface EmptyListTableProps {
    text: string
}


export function EmptyListResultTable({ text }: EmptyListTableProps) {
    const styles = useStyles();
    return (
        <div className={styles.emptyListContainer}>
            <Divider />
            <Typography className={styles.emptyListText}>
                {text}
            </Typography>
            <Divider />
        </div>
    )
}

const useStyles = makeStyles(() => ({
    emptyListContainer: {
        marginTop: theme.spacing(3),
    },
    emptyListText: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        marginLeft: theme.spacing(3),
    },
}));
